import React, { createContext, useState, useContext } from "react";

export const MenuBarContext = createContext();

const MenuBarProvider = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const openMenu = () => setIsMenuOpen(true);
  const closeMenu = () => setIsMenuOpen(false);
  const toggleMenu = () => setIsMenuOpen((prev) => !prev);
  return (
    <MenuBarContext.Provider
      value={{ isMenuOpen, openMenu, closeMenu, toggleMenu }}
    >
      {children}
    </MenuBarContext.Provider>
  );
};

export default MenuBarProvider;
